import * as React from 'react';
import { Provider } from 'react-redux';
import BootstrapContainer from './bootstrap_container';
import CodeSplitLoadingSpinner from './LoadingSpinner';
import { Router, Route } from 'react-router-dom';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
import { createBrowserHistory } from 'history';
import { PortalDynamicValuesProvider } from '../DynamicValues';
import { PortalDVSClientProvider, DVSLoader } from '../DV2';
import { hasLocaleInPath, getNormalizedPathAndLocale, } from '../../i18n/utils/localize-route';
import i18n from '../../i18n';
var PortalContainer = React.lazy(function () { return import('./portal_container'); });
var TeamNotFound = React.lazy(function () { return import('../../components/TeamNotFound/team_not_found'); });
var PortalProvider = function (_a) {
    var _b = _a.reduxStore, reduxStore = _b === void 0 ? {} : _b;
    var history = createBrowserHistory();
    /**
     * Cleaning up locale in path is applied here
     * because we do not want locale check to be done on every url change.
     * We are cleaning up the url/history to one without the locale
     */
    // Allow i18n in path to force locale
    var pathname = history.location.pathname;
    if (hasLocaleInPath(pathname)) {
        var _c = getNormalizedPathAndLocale(pathname), normalizedPath = _c.normalizedPath, localeInPath = _c.localeInPath;
        if (localeInPath) {
            // prioritize locale on URL over cookie
            i18n.changeLocale(localeInPath);
        }
        // i18n locale is set in the cookie. we do not need to keep locale in URL
        history.push({
            pathname: normalizedPath,
            search: history.location.search, // carrying it over from original url
        });
    }
    return (React.createElement(Provider, { store: reduxStore },
        React.createElement(PortalDynamicValuesProvider, null,
            React.createElement(PortalDVSClientProvider, null,
                React.createElement(DVSLoader, null,
                    React.createElement(Router, { history: history },
                        React.createElement(React.Suspense, { fallback: React.createElement(CodeSplitLoadingSpinner, null) },
                            React.createElement(BootstrapContainer, { protectedRoutes: [
                                    React.createElement(Route, { exact: true, path: PORTAL_ROUTE_PREFIX + "/team-not-found", component: TeamNotFound }),
                                    React.createElement(Route, { component: PortalContainer }),
                                ] }))))))));
};
export default PortalProvider;
